import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { createWrapper } from "next-redux-wrapper";

import userReducer from "./slices/userSlice";
import themeReducer from "./slices/themeSlice";
import authSlice from "./slices/authSlice";
import settingsSlice from "./slices/settingSlice";

const store = () =>
	configureStore({
		reducer: {
			auth: authSlice,
			user: userReducer,
			theme: themeReducer,
			settings: settingsSlice,
		},
		// middleware: (getDefaultMiddleware) =>
		//     getDefaultMiddleware({ serializableCheck: false }),
		devTools: true,
	});

export const wrapper = createWrapper(store);
